import { render, staticRenderFns } from "./FeatureBlock.vue?vue&type=template&id=55b4f807&scoped=true&"
import script from "./FeatureBlock.vue?vue&type=script&lang=js&"
export * from "./FeatureBlock.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBlock.vue?vue&type=style&index=0&id=55b4f807&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4f807",
  null
  
)

export default component.exports